import { Fieldset, Grid, NumberInput } from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { UseFormReturnType } from "@mantine/form";
import { IconCurrencyPound } from "@tabler/icons-react";
import { BalanceDay } from "../../../backend/build-ledger";
import { LocalDate } from "@js-joda/core";
import { FormInputs } from "./Projector";

export type PresentationalTransaction = BalanceDay & {
  toDate: LocalDate;
};

export function FormV2({ form }: { form: UseFormReturnType<FormInputs> }) {
  return (
    <form>
      <Fieldset>
        <Grid justify="center">
          <Grid.Col span={3}>
            <DatePickerInput
              withAsterisk
              label="From"
              {...form.getInputProps("startDate")}
            />
          </Grid.Col>

          <Grid.Col span={3}>
            <NumberInput
              withAsterisk
              leftSection={<IconCurrencyPound />}
              label="Opening Balance"
              {...form.getInputProps("initialBalance")}
            />
          </Grid.Col>

          <Grid.Col span={3}>
            <DatePickerInput
              withAsterisk
              label="To"
              {...form.getInputProps("endDate")}
            />
          </Grid.Col>
        </Grid>
      </Fieldset>
    </form>
  );
}
